import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'ngbd-carousel',
  templateUrl: './carousel.html',
  styleUrls: ['./carousel.scss']
})
export class NgbdCarousel implements OnInit {
  @Input() bannerData;

  constructor() {}

  ngOnInit() {}
}
